var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"check-sales-box",attrs:{"id":"myElement"},on:{"click":_vm.goProgram}},[_c('img',{attrs:{"src":_vm.checkSalesImgUrl1,"alt":"抖音兑换流程"}})]),_vm._v(" "),_c('div',{staticClass:"btn-box"},[_c('div',{staticClass:"copy",on:{"click":_vm.copyClick}},[_c('div',{staticClass:"tips"},[_vm._v("复制去搜索")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b4a069","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/userMessage.vue
// module id = null
// module chunks = 